import { twMerge } from 'tailwind-merge';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import SearchIcon from '../../../components/icons/SearchIcon';
import { Copy } from '../../../components/Typography';
import useFeatureFlags from '../../../hooks/useFeatureFlags';
import ClearSearchIcon from '../../../components/icons/ClearSearchIcon';

type Props = {
  search: string;
  onChange: (value: string) => void;
  className?: string;
};

export default function TailorSearchInput({ search, className, onChange }: Props) {
  const { uiRefreshPreLaunchUiUpdates } = useFeatureFlags();
  const { t } = useTranslation();
  const ref = useRef<HTMLInputElement>(null);
  const handleClearSearchClick = () => {
    onChange?.('');
  };

  useEffect(() => {
    ref.current?.focus({ preventScroll: true });
  }, []);

  return (
    <div
      id="ostro-tailor-search-input-container"
      className={twMerge('relative', className)}
    >
      <input
        id="ostro-tailor-search-input"
        ref={ref}
        type="text"
        value={search}
        onChange={(event) => {
          onChange?.(event.target.value);
        }}
        placeholder={t('search_placeholder')}
        className="cursor-pointer w-full inline-block font-semibold border-b-1 border-dotted border-black py-2 px-1 text-lg bg-transparent outline-none pr-[36px] placeholder:font-normal placeholder-typography-heading"
      />
      {search ? (
        uiRefreshPreLaunchUiUpdates ? (
          <ClearButtonV2 onClick={handleClearSearchClick} />
        ) : (
          <ClearButtonV1 onClick={handleClearSearchClick} />
        )
      ) : (
        <SearchIcon className="right-0 top-0 absolute mr-1 mt-2.5 inline" />
      )}
    </div>
  );
}

const ClearButtonV1 = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      id="ostro-tailor-clear-search-button"
      onClick={onClick}
    >
      <ClearSearchIcon className="right-0 top-0 absolute mr-1 mt-2.5 inline" />
    </button>
  );
};

const ClearButtonV2 = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <button
      className="right-0 top-0 absolute mr-1 mt-4 inline"
      id="ostro-tailor-clear-search-button"
      onClick={onClick}
    >
      <Copy className="text-typography-secondary">{t('clear_button')}</Copy>
    </button>
  );
};
